

























































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import RangeSlider from "@/components/VRangeSliderStyling.vue";

import ColorPicker from '@/commonComponents/colorPicker/colorPicker.vue';
import DropdownList from "@/commonComponents/dropdownList/dropdownList.vue";

import * as def from "@/definitions";

import { DateTextLayer } from "@/model/document2/page/surface/design/layer/dateTextLayer";
import { ColorConstruct } from "@/utilityModels/colorConstruct";

import ValueEdit from "@/commonComponents/valueEdit/valueEdit.vue";
import { TextInfo } from '@/utilityModels/textInfo';
import { MathHelper } from '@/helper/mathHelper';
import { FontManager } from '@/model/fontManager/fontManager';

import ColorSelector from "@/commonComponents/colorSelector/colorSelector.vue";
import FontSelector from "@/commonComponents/fontSelector/fontSelector.vue";
import AdjustedBalloon from '@/commonComponents/adjustedBalloon/adjustedBalloon.vue';

// ボタン
import ArrowDown from "../resources/arrowDown.vue";
import ArrowRight from "../resources/arrowRight.vue";
import CheckBoxOn from "../resources/checkBoxOn.vue";
import RadioOn from "../resources/radioOn.vue";
import AlignLeftOn from "../resources/alignLeft_on.vue";
import AlignLeftOff from "../resources/alignLeft_off.vue";
import AlignCenterOn from "../resources/alignCenter_on.vue";
import AlignCenterOff from "../resources/alignCenter_off.vue";
import AlignRightOn from "../resources/alignRight_on.vue";
import AlignRightOff from "../resources/alignRight_off.vue";
import AlignEvenOn from "../resources/alignEven_on.vue";
import AlignEvenOff from "../resources/alignEven_off.vue";
import AlignTopOn from "../resources/alignTop_on.vue";
import AlignTopOff from "../resources/alignTop_off.vue";
import AlignMiddleOn from "../resources/alignMiddle_on.vue";
import AlignMiddleOff from "../resources/alignMiddle_off.vue";
import AlignBottomOn from "../resources/alignBottom_on.vue";
import AlignBottomOff from "../resources/alignBottom_off.vue";

import { ResourceHelper } from "@/helper/resourceHelper"


@Component({
  components: {
    RangeSlider,
    ColorPicker,
    ValueEdit,
    DropdownList,
    ColorSelector,
    FontSelector,
    AdjustedBalloon,

    ArrowDown,
    ArrowRight,
    CheckBoxOn,
    RadioOn,
    AlignLeftOn,
    AlignLeftOff,
    AlignCenterOn,
    AlignCenterOff,
    AlignRightOn,
    AlignRightOff,
    AlignEvenOn,
    AlignEvenOff,
    AlignTopOn,
    AlignTopOff,
    AlignMiddleOn,
    AlignMiddleOff,
    AlignBottomOn,
    AlignBottomOff
  }
})

// テキスト編集中かつ文字列非選択 / テキスト非選択中
// このとき、設定は文字列全てに反映する。
export default class DateTextStyle extends Vue
{
    @Prop() private layer!: DateTextLayer;

    private changeInputMode(mode)
    {
        this.$store.dispatch("changeInputMode", mode);
    }

    // フォント
    private isFontDropdownActive : boolean = false;
    private dropdownListVisibleChanged(isVisible : boolean)
    {
        this.isFontDropdownActive = isVisible;
    }
    private get selectedFontId() { return this.layer.textInfo.fontId; }
    private getFontManager() : FontManager
    {
        return this.$store.getters.fontManager;
    }
    private onSelectFont(fontId: string)
    {
        var textInfo = this.layer.textInfo.clone();
        textInfo.fontId = fontId;
        this.changeLayerProperty(textInfo, "textInfo", true, true);
    }

    // テキスト色
    private get textColor()
    {
        return this.layer.textInfo.textColor;
    }
    private get textColorHex()
    {
        return this.layer.textInfo.textColor.hex;
    }
    // 色変更中
    private onChangingColor(color, tag)
    {
        if(tag == "textColor")
        {
            var textInfo = this.layer.textInfo.clone();
            textInfo.textColor = color;
            this.changeLayerProperty(textInfo, "textInfo", false);
        }
    }

    // 色変更完了
    private onChangedColor(color, tag)
    {
        if(tag == "textColor")
        {
            var textInfo = this.layer.textInfo.clone();
            textInfo.textColor = color;
            this.changeLayerProperty(textInfo, "textInfo", true);
        }
    }

    // 不透明度
    private get opacity()
    {
        return this.layer.opacity;
    }
    private get opacitySliderValue()
    {
        return this.opacity;
    }
    private set opacitySliderValue(value)
    {
        this.changeLayerProperty(value, "opacity", false);
    }
    private onChangeOpacity(value)
    {
        this.changeLayerProperty(value, "opacity", true);
    }

    // 区切り
    public static readonly SPLITTYPE_STRING = ["年月日", "ドット", "スラッシュ", "ハイフン", "スペース"];
    private get splitTypeText()
    {
        return DateTextStyle.SPLITTYPE_STRING[this.layer.splitType];
    }
    isSeparationDropdownVisible = false;
    private get separationDropdownItems()
    {
        var items = new Array();
        for(var i = 0; i < DateTextStyle.SPLITTYPE_STRING.length; ++i)
        {
            items.push({
                id : i,
                isSelected : i == this.layer.splitType,
                label : DateTextStyle.SPLITTYPE_STRING[i]
            });
        }
        return items;
    }
    private setSplitType(id: number, tag: string)
    {
        this.isSeparationDropdownVisible = false;
        this.changeLayerProperty(id, "splitType", true, true);
    }

    // 年
    private get yearTypeText()
    {
        var str = this.layer.dateData.getYearString(this.layer.yearType);
        return str != "" ? str : "(なし)";
    }
    isYearDropdownVisible = false;
    private get yearDropdownItems()
    {
        var items = new Array();
        for(var i = 0; i < 6; ++i)
        {
            var str = this.layer.dateData.getYearString(i);
            items.push({
                id : i,
                isSelected : i == this.layer.yearType,
                label : str != "" ? str : "(なし)"
            });
        }
        return items;
    }
    private setYearType(id: number, tag: string)
    {
        this.isYearDropdownVisible = false;
        this.changeLayerProperty(id, "yearType", true, true);
    }

    // 月
    private get monthTypeText()
    {
        var str = this.layer.dateData.getMonthString(this.layer.monthType, this.layer.is2Digits);
        return str != "" ? str : "(なし)";
    }
    isMonthDropdownVisible = false;
    private get monthDropdownItems()
    {
        var items = new Array();
        for(var i = 0; i < 4; ++i)
        {
            var str = this.layer.dateData.getMonthString(i, this.layer.is2Digits);
            items.push({
                id : i,
                isSelected : i == this.layer.monthType,
                label : str != "" ? str : "(なし)"
            });
        }
        return items;
    }
    private setMonthType(id: number, tag: string)
    {
        this.isMonthDropdownVisible = false;
        this.changeLayerProperty(id, "monthType", true, true);
    }

    // 日
    private get dayTypeText()
    {
        var str = this.layer.dateData.getDayString(this.layer.dayType, this.layer.is2Digits);
        return str != "" ? str : "(なし)";
    }
    isDayDropdownVisible = false;
    private get dayDropdownItems()
    {
        var items = new Array();
        for(var i = 0; i < 2; ++i)
        {
            var str = this.layer.dateData.getDayString(i, this.layer.is2Digits);
            items.push({
                id : i,
                isSelected : i == this.layer.dayType,
                label : str != "" ? str : "(なし)"
            });
        }
        return items;
    }
    private setDayType(id: number, tag: string)
    {
        this.isDayDropdownVisible = false;
        this.changeLayerProperty(id, "dayType", true, true);
    }

    // 曜日
    private get weekdayTypeText()
    {
        var str = this.layer.dateData.getWeekdayString(this.layer.weekdayType);
        return str != "" ? str : "(なし)";
    }
    isWeekdayDropdownVisible = false;
    private get weekdayDropdownItems() {
        var items = new Array();
        for(var i = 0; i < 11; ++i)
        {
            var str = this.layer.dateData.getWeekdayString(i);
            items.push({
                id : i,
                isSelected : i == this.layer.dayType,
                label : str != "" ? str : "(なし)"
            });
        }
        return items;
    }
    private setWeekdayType(id: number, tag: string)
    {
        this.isWeekdayDropdownVisible = false;
        this.changeLayerProperty(id, "weekdayType", true, true);
    }

    // 月日2桁
    private get is2Digits() { return this.layer.is2Digits; }
    private is2DigitsChange()
    {
        this.changeLayerProperty(!this.is2Digits, "is2Digits", true, true);
    }

    // 増減選択
    static readonly DELTA_KIND = ["年", "月", "日"]
    private get selectedDeltaText()
    {
        return DateTextStyle.DELTA_KIND[this.layer.selectedDelta];
    }
    isIncrementTypeDropdownVisible = false;
    private get incrementTypeDropdownItems() {
        var items = new Array();
        for(var i = 0; i < DateTextStyle.DELTA_KIND.length; ++i)
        {
            items.push({
                id : i,
                isSelected : i == this.layer.selectedDelta,
                label : DateTextStyle.DELTA_KIND[i]
            });
        }
        return items;
    }
    private setSelectedDelta(id: number, tag: string)
    {
        this.isIncrementTypeDropdownVisible = false;
        this.changeLayerProperty(id, "selectedDelta", true, true);
    }

    // 増減
    private get dateDelta()
    {
        return this.layer.dateDelta;
    }

    private onChangingValue(value, tag)
    {
        this.changeLayerProperty(value, tag, false);
    }
    private onChangedValue(value, tag)
    {
        this.changeLayerProperty(value, tag, true);
    }

    // 語頭・語尾
    private get prefix()
    {
        return this.layer.prefix;
    }
    private onSetPrefix(value, isFinish)
    {
        if(isFinish)
        {
            this.changeInputMode(0);
        }
        else
        {
            this.changeInputMode(1);
        }
        this.changeLayerProperty(value, "prefix", isFinish);
    }
    private get suffix()
    {
        return this.layer.suffix;
    }
    private onSetSuffix(value, isFinish)
    {
        if(isFinish)
        {
            this.changeInputMode(0);
        }
        else
        {
            this.changeInputMode(1);
        }
        this.changeLayerProperty(value, "suffix", isFinish);
    }

    // フォントサイズ
    private get fontSize()
    {
        return this.layer.textInfo.fontSize;
    }
    private onChangingTextInfo(value, tag)
    {
        var textInfo = this.layer.textInfo.clone();
        textInfo[tag] = value;
        this.changeLayerProperty(textInfo, "textInfo", false);
    }
    private onChangedTextInfo(value, tag)
    {
        var textInfo = this.layer.textInfo.clone();
        textInfo[tag] = value;
        this.changeLayerProperty(textInfo, "textInfo", true);
    }

    // 自動
    private get autoSize()
    {
        return this.layer.autoSize;
    }
    private autoSizeChange()
    {
        var newValue = this.layer.autoSize == true ? false : true;
        this.changeLayerProperty(newValue, "autoSize", true, true);
    }

    // 自動折り返し
    private get autoNewLine()
    {
        return this.layer.autoNewLine;
    }

    private autoNewLineChange()
    {
        var newValue = this.layer.autoNewLine == true ? false : true;
        this.changeLayerProperty(newValue, "autoNewLine", true, true);
    }

    // 字間
    private get letterSpacing()
    {
        return this.layer.textInfo.letterSpacing;
    }

    // 行間
    private get lineSpacing()
    {
        return this.layer.lineSpacing;
    }

    // 横書き・縦書き
    private get isTextOrientationVertical()
    {
        return this.layer.textOrientation == 1;
    }
    private setTextOrientation(orientation)
    {
        // 文字方向切り替え
        var value = orientation == "vertical" ? 1 : 0;
        this.changeLayerProperty(value, "textOrientation", true, true);
    }

    // 水平・垂直揃え
    private isHorizontalAlignment(type)
    {
        var result = false;
        if(type == "left")
        {
            result = this.layer.horizontalAlignment == 0;
        }
        else if(type == "center")
        {
            result = this.layer.horizontalAlignment == 1;
        }
        else if(type == "right")
        {
            result = this.layer.horizontalAlignment == 2;
        }
        else if(type == "even")
        {
            result = this.layer.horizontalAlignment == 3;
        }
        return result;
    }

    private isVerticalAlignment(type)
    {
        var result = false;
        if(type == "top")
        {
            result = this.layer.verticalAlignment == 0;
        }
        else if(type == "center")
        {
            result = this.layer.verticalAlignment == 1;
        }
        else if(type == "bottom")
        {
            result = this.layer.verticalAlignment == 2;
        }
        return result;
    }

    private setHorizontalAlignment(type)
    {
        var newAlignment = this.layer.horizontalAlignment;

        if(type == "left") { newAlignment = 0; }
        else if(type == "center") { newAlignment = 1; }
        else if(type == "right") { newAlignment = 2; }
        else if(type == "even") { newAlignment = 3; }

        if(newAlignment != this.layer.horizontalAlignment)
        {
            this.changeLayerProperty(newAlignment, "horizontalAlignment", true, true);
        }
    }

    private setVerticalAlignment(type)
    {
        var newAlignment = this.layer.verticalAlignment;

        if(type == "top") { newAlignment = 0; }
        else if(type == "center") { newAlignment = 1; }
        else if(type == "bottom") { newAlignment = 2; }

        if(newAlignment != this.layer.verticalAlignment)
        {
            this.changeLayerProperty(newAlignment, "verticalAlignment", true, true);
        }
    }


    private getPropertyValue(propertyName)
    {
        return 0
        // return this.layer.inEdit ? this.currentTextInfo[propertyName] : this.getCurrentValueInfo(propertyName).value;
    }
    private getPropertyBlank(propertyName) {
        return 0
        // return this.layer.inEdit ? false : this.getCurrentValueInfo(propertyName).isBlank;
    }

    // 太字、斜体、下線
    private get bold()
    {
        return this.layer.textInfo.bold;
    }

    private boldChange()
    {
        var textInfo = this.layer.textInfo.clone();
        textInfo.bold = !textInfo.bold;
        this.changeLayerProperty(textInfo, "textInfo", true);
    }

    private get italic()
    {
        return this.layer.textInfo.italic;
    }

    private italicChange()
    {
        var textInfo = this.layer.textInfo.clone();
        textInfo.italic = !textInfo.italic;
        this.changeLayerProperty(textInfo, "textInfo", true);
    }

    private get underline()
    {
        return this.layer.textInfo.underline;
    }

    private underlineChange()
    {
        var textInfo = this.layer.textInfo.clone();
        textInfo.underline = !textInfo.underline;
        this.changeLayerProperty(textInfo, "textInfo", true);
    }

    // 文字幅
    private get letterWidth()
    {
        return this.layer.textInfo.letterWidth;
    }

    // 全角
    private get isEmQuad()
    {
        return this.layer.textInfo.isEmQuad;
    }
    private isEmQuadChange()
    {
        var textInfo = this.layer.textInfo.clone();
        textInfo.isEmQuad = !textInfo.isEmQuad;
        this.changeLayerProperty(textInfo, "textInfo", true);
    }

    //↓↓↓↓↓開閉のアニメーション↓↓↓↓↓
    //TODO Props
    openStatus = {
        opend: true
    };

    dateTextTransformContentsOpenAnimate = false;
    dateTextTransformContentsCloseAnimate = false;

    open() {
        if (this.openStatus.opend) {
        this.dateTextTransformContentsCloseAnimate = true;
        setTimeout(() => {
            this.dateTextTransformContentsCloseAnimate = false;
            this.dateTextTransformContentsOpenAnimate = false;
            this.openStatus.opend = false;
        }, 200);
        } else {
        this.openStatus.opend = true;
        this.dateTextTransformContentsOpenAnimate = true;
        setTimeout(() => {
            this.dateTextTransformContentsOpenAnimate = false;
        }, 250);
        }
    }
    //↑↑↑↑↑開閉のアニメーション↑↑↑↑↑

    // カラーピッカー表示非表示
    isColorPickerVisible = false;
    showColorPicker() {
        this.isColorPickerVisible = true;
    }
    closeColorPicker() {
        this.isColorPickerVisible = false;
    }

    private changeLayerProperty(value : any, propertyName : string, isFinish : boolean = false, isOnce : boolean = false)
    {
        this.$emit("doCommand", "changeLayerProperty", {
            layer : this.layer,
            propertyName : propertyName,
            value : value,
            isFinish : isFinish,
            isOnce : isOnce
        });
    }

    private get textTransformOpendStyle(){
        var style = {};
        if(this.applicationState.flowMode != 0 && this.openStatus.opend){
            style = {
                height: "calc(878% / 752 * 100) !important"
            };
        }
        return style;
    }

    private get commonGroupStyle(){
        var style = {};
        if(this.applicationState.flowMode != 0){
            style = {
                height: "4.74%"
            };
        }
        return style;
    }

    private get buttonGroupStyle(){
        var style = {};
        if(this.applicationState.flowMode != 0){
            style = {
                height: "6.13%"
            };
        }
        return style;
    }

    private get applicationState(){
        return this.$store.getters.applicationState;
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigUnderLineColor(){
        var style = {
            backgroundColor : this.userConfigColor
        };
        return style;
    }

    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }

    private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }

}
